import React, { useEffect } from 'react';
import MainContainer from '@/widgets/MainContainer/MainContainer';
import { StoreWrapper } from '@/utils/providers/StoreProvider';
import { PopupProvider } from 'tkmp-lib/src/providers/PopupProvider';
import { usePathname } from 'next/navigation';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import { useStores } from '@/utils/hooks/useStores';
import { useRouter } from 'next/router';
import { setCookie } from 'cookies-next';

const WithMainContainer = (WrappedComponent: any) => {
    return (props: React.JSX.IntrinsicAttributes) => {
        const router = useRouter();
        const pathname = usePathname();

        const {
            userStore: { clearUser },
        } = useStores();

        useEffect(() => {
            AuthService.validateAuth().then((answer) => {
                if (!answer) AuthService.logout().then((_) => clearUser());
            });
        }, [pathname]);
        useEffect(() => {
            setCookie('lang', router.locale ?? 'ru');
        }, [router]);

        return (
            <StoreWrapper>
                <PopupProvider>
                    <MainContainer {...props}>
                        <WrappedComponent {...props} />
                    </MainContainer>
                </PopupProvider>
            </StoreWrapper>
        );
    };
};

export default WithMainContainer;
